const api = {
  GET_LIST_CALLBACK_API_LOG: '/index.php?r=api/v1/system_log/service-log/callback-notification-log',
};

export default api;
